import useTranslation from 'next-translate/useTranslation';
import SubtitleText, { ISubtitleTextProps } from 'src/themes/cosmos/components/SubtitleText';
import classNames from 'classnames';
import styles from './styles.module.scss';

type ISubtitleTextPreviewProps = Omit<ISubtitleTextProps, 'currentText'>;

const SubtitleTextPreview = ({ color, size, stroke, background, className }: ISubtitleTextPreviewProps) => {
  const { t } = useTranslation('common');
  return (
    <div className={classNames(styles.container, className)}>
      <SubtitleText
        currentText={t('settings.subtitle.preview_text')}
        className={styles.subtitleText}
        color={color}
        size={size}
        stroke={stroke}
        background={background}
      />
    </div>
  );
};

export default SubtitleTextPreview;
